import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MonitoringPageComponent } from './pages/monitoring-page/monitoring-page.component';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { UserRole } from '@reenstudio/app/core/enum/user-role';

const routes: Routes = [
  {
    path: '',
    component: MonitoringPageComponent,
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: [
          UserRole.ADMIN,
          UserRole.CER,
          UserRole.INTRAPRESA,
          UserRole.SITE,
        ],
      },
      title: 'Storico',
      urls: [
        { title: 'Storico', url: '/history' },
        { title: 'Analisi dati storici' },
      ],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MonitoringRoutingModule {}
